<template>
    <div class="" style="background-color: #fff; padding: 20px; box-sizing: border-box">
        <div class="header_warpper">
            <div class="left">
                <el-tabs v-model="query.type" @tab-click="handleClick" style="margin-right: 10px">
                    <el-tab-pane label="今日" name="1"></el-tab-pane>
                    <el-tab-pane label="昨日" name="2"></el-tab-pane>
                    <el-tab-pane label="本周" name="3"></el-tab-pane>
                    <el-tab-pane label="上周" name="4"></el-tab-pane>
                </el-tabs>
                <el-input v-model="query.seek" placeholder="单号/备注" style="margin-left: 68px; margin-bottom: 10px"></el-input>
                <el-button type="primary" style="margin-right: 10px; margin-bottom: 10px" @click="searchIt">{{ $t('common.search') }}</el-button>
                <el-button plain @click="dialogVisible = true" style="margin-bottom: 10px">{{ $t('common.filter') }}</el-button>
            </div>

            <div class="right" style="margin-bottom: 10px">
                <el-button type="" plain @click="refush">{{ $t('common.refresh') }}</el-button>
                <el-button type="primary" @click="add" style="margin-right: 10px">{{ $t('common.add') }}</el-button>
                <el-dropdown trigger="click" @command="handleCommand">
                    <el-button plain> 批量操作<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="1">{{ $t('common.audit') }}</el-dropdown-item>
                        <el-dropdown-item command="2">反审</el-dropdown-item>
                        <el-dropdown-item command="3">{{ $t('common.delete') }}</el-dropdown-item>
                        <el-dropdown-item command="4">{{ $t('common.export') }}</el-dropdown-item>
                        <el-dropdown-item command="5"> 导入 </el-dropdown-item>
                        <el-dropdown-item command="6"> 导入模板 </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <el-upload
            v-show="false"
            style="border: none; color: #000"
            class="biaoge"
            action=""
            :on-change="inExcel"
            :show-file-list="false"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
            :auto-upload="false"
        >
        </el-upload>
        <div>
            <vxe-table
                border
                auto-resize
                :data="backData"
                ref="table"
                height="620"
                :footer-method="footerMethod"
                show-footer
                :key="refushTable"
            >
                <vxe-table-column type="checkbox" fixed="left" width="50" align="center"></vxe-table-column>
                <vxe-table-column title="序号" type="seq" field="seq" fixed="left" width="50" align="center">
                    <template slot="header">
                        <i class="el-icon-setting" style="font-size: 18px" @click="changeTable"></i>
                    </template>
                </vxe-table-column>
                <template v-for="(item, index) in rkKeyList">
                    <vxe-table-column
                        :key="item.field + index"
                        :field="item.field"
                        :title="item.column_name"
                        align="left"
                        :width="item.column_width"
                        v-if="item.column_status == 1 && item.field_name != '审核'"
                    >
                    </vxe-table-column>
                    <!-- <vxe-table-column
                        :key="item.field + index"
                        :prop="item.field"
                        :label="item.column_name"
                        :width="item.column_width"
                        v-else-if="item.field_name == '单号' && item.column_status == 1"
                    >
                        <template slot-scope="scope">
                            <el-button type="text" @click="handleDetails(scope.row)">{{ scope.row[item.field] }}</el-button>
                        </template>
                    </vxe-table-column> -->
                    <vxe-table-column
                        :key="item.field + index"
                        :prop="item.field"
                        :label="item.column_name"
                        :width="item.column_width"
                        v-else-if="item.field_name == '审核' && item.column_status == 1"
                    >
                        <template #default="{ row }">
                            <el-tag :type="row.check == 1 ? 'success' : 'danger'">{{ row.check == 1 ? $t('common.audited') : $t('common.notAudited') }}</el-tag>
                        </template>
                    </vxe-table-column>
                </template>
                <vxe-table-column title="操作" field="" fixed="right" width="210">
                    <template #default="{ row }">
                        <el-button type="primary" plain @click="Edit(row)">{{ $t('common.edit') }}</el-button>
                        <el-button type="danger" plain @click="deleteIt(row)">{{ $t('common.delete') }}</el-button>
                        <el-button type="warning" plain @click="Check(row)">{{ row.check == '1' ? '反审' : '审核' }}</el-button>
                    </template>
                </vxe-table-column>
                <template #empty>
                    <span style="color: red">
                        <img src="@/assets/img/dontHave.png" style="width: 180px" />
                    </span>
                </template>
            </vxe-table>
            <div class="pagination" style="text-align: right">
                <el-pagination
                    background
                    layout="total,sizes, prev, pager, next"
                    :current-page="query.page"
                    :page-size="query.page_size"
                    :page-sizes="[10, 20, 30, 40]"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                    @size-change="pageSizeChange"
                ></el-pagination>
            </div>
        </div>
        <el-drawer :title="isAdd ? $t('common.add') : $t('common.edit')" :visible.sync="drawer" direction="rtl">
            <div class="drawer">
                <el-form :model="form" style="padding: 20px; box-sizing: border-box" ref="from" :rules="rules">
                    <el-row :gutter="30">
                        <el-col :span="12">
                            <el-form-item :label="$t('common.billNo')" required>
                                <el-input placeholder="" v-model="form.banktransfer_no" disabled></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="日期" prop="banktransfer_date">
                                <el-date-picker
                                    type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="选择日期"
                                    v-model="form.banktransfer_date"
                                    style="width: 100%"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="$t('common.billType') + '：'" prop="billtype_no">
                                <el-select
                                    v-model="form.billtype_no"
                                    filterable
                                    default-first-option
                                    clearable
                                    placeholder="请选择"
                                    style="width: 100%"
                                >
                                    <el-option
                                        v-for="(item, index) in pullData.billtype"
                                        :key="index"
                                        :label="item.billtype_no + ' - ' + item.billtype_name"
                                        :value="item.billtype_no.toString()"
                                        :disabled="item.status == 0"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="转出银行" prop="outbank_no">
                                <el-select
                                    v-model="form.outbank_no"
                                    filterable
                                    default-first-option
                                    clearable
                                    placeholder="请选择"
                                    style="width: 100%"
                                >
                                    <el-option
                                        v-for="(item, index) in pullData.bank"
                                        :key="index"
                                        :label="item.bank_no + ' - ' + item.bank_name"
                                        :value="item.bank_no.toString()"
                                        :disabled="item.status == 0"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="转入银行" prop="intbank_no">
                                <el-select
                                    v-model="form.intbank_no"
                                    filterable
                                    default-first-option
                                    clearable
                                    placeholder="请选择"
                                    style="width: 100%"
                                >
                                    <el-option
                                        v-for="(item, index) in pullData.bank"
                                        :key="index"
                                        :label="item.bank_no + ' - ' + item.bank_name"
                                        :value="item.bank_no.toString()"
                                        :disabled="item.status == 0"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="$t('common.currency') + '：'" prop="currency_no">
                                <el-select
                                    v-model="form.currency_no"
                                    filterable
                                    default-first-option
                                    clearable
                                    placeholder="请选择"
                                    style="width: 100%"
                                >
                                    <el-option
                                        v-for="(item, index) in pullData.currency"
                                        :key="index"
                                        :label="item.currency_no + ' - ' + item.currency_name"
                                        :value="item.currency_no.toString()"
                                        :disabled="item.status == 0"
                                    >
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="金额" prop="amt">
                                <el-input
                                    v-model="form.amt"
                                    min="0"
                                    type="number"
                                    @blur="$vaildator.amt(form)"
                                    placeholder="请输入"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item :label="$t('common.store') + '：'">
                                <mySelect
                                    v-model="form.store_no"
                                    :options="pullData.store"
                                    values="store_no"
                                    labels="store_name"
                                    keys="store_no"
                                    :clearables="false"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="24"
                            ><el-form-item :label="$t('common.remark')">
                                <el-input type="textarea" :rows="2" v-model="form.remark"></el-input> </el-form-item
                        ></el-col>
                    </el-row>
                </el-form>
                <div class="dialog-footer">
                    <el-button @click="drawer = false">取 消</el-button>
                    <el-button type="primary" @click="addIt">确 定</el-button>
                </div>
            </div>
        </el-drawer>
        <el-dialog :title="$t('common.filter')" :visible.sync="dialogVisible" width="30%">
            <div class="dialog">
                <div style="margin-top: 20px" class="block">
                    <p>日期</p>
                    <el-radio-group v-model="query.type" size="medium">
                        <el-radio-button label="1">今日</el-radio-button>
                        <el-radio-button label="2">昨日</el-radio-button>
                        <el-radio-button label="3">本周</el-radio-button>
                        <el-radio-button label="4">上周</el-radio-button>
                        <el-radio-button label="5">本月</el-radio-button>
                        <el-radio-button label="6">上月</el-radio-button>
                    </el-radio-group>
                </div>

                <div class="block">
                    <p class="demonstration">自定义</p>
                    <el-date-picker
                        v-model="value2"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        align="right"
                        style="width: 80%"
                        @change="changeDate"
                        value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                </div>
                <div class="block">
                    <p class="demonstration">{{ $t('common.billType') }}</p>
                    <el-select
                        v-model="query.billtype_no"
                        filterable
                        default-first-option
                        clearable
                        placeholder="请选择"
                        style="width: 80%"
                    >
                        <el-option
                            v-for="(item, index) in pullData.billtype"
                            :key="index"
                            :label="item.billtype_no + ' - ' + item.billtype_name"
                            :value="item.billtype_no.toString()"
                            :disabled="item.status == 0"
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="block">
                    <p>{{ $t('common.auditStatus') }}</p>
                    <el-radio-group v-model="query.check">
                        <el-radio label="0">{{ $t('common.all') }}</el-radio>
                        <el-radio label="未审核">未审核</el-radio>
                        <el-radio label="已审核">已审核</el-radio>
                    </el-radio-group>
                </div>
                <div class="block">
                    <p class="demonstration">转出银行</p>
                    <el-select v-model="query.outbank_no" filterable default-first-option clearable placeholder="请选择" style="width: 80%">
                        <el-option
                            v-for="(item, index) in pullData.bank"
                            :key="index"
                            :label="item.bank_no + ' - ' + item.bank_name"
                            :value="item.bank_no.toString()"
                            :disabled="item.status == 0"
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="block">
                    <p class="demonstration">转入银行</p>
                    <el-select v-model="query.intbank_no" filterable default-first-option clearable placeholder="请选择" style="width: 80%">
                        <el-option
                            v-for="(item, index) in pullData.bank"
                            :key="index"
                            :label="item.bank_no + ' - ' + item.bank_name"
                            :value="item.bank_no.toString()"
                            :disabled="item.status == 0"
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="block">
                    <p class="demonstration">币别</p>
                    <el-select
                        v-model="query.currency_no"
                        filterable
                        default-first-option
                        clearable
                        placeholder="请选择"
                        style="width: 80%"
                    >
                        <el-option
                            v-for="(item, index) in pullData.currency"
                            :key="index"
                            :label="item.currency_no + ' - ' + item.currency_name"
                            :value="item.currency_no.toString()"
                            :disabled="item.status == 0"
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="block">
                    <p class="demonstration">建单人</p>
                    <el-select v-model="query.build_no" filterable default-first-option clearable placeholder="请选择" style="width: 80%">
                        <el-option
                            v-for="(item, index) in pullData.staff"
                            :key="index"
                            :label="item.staff_no + ' - ' + item.staff_name"
                            :value="item.staff_no"
                            :disabled="item.status == 0"
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="block">
                    <p class="demonstration">{{ $t('common.modifier') }}</p>
                    <el-select v-model="query.modify_no" filterable default-first-option clearable placeholder="请选择" style="width: 80%">
                        <el-option
                            v-for="(item, index) in pullData.staff"
                            :key="index"
                            :label="item.staff_no + ' - ' + item.staff_name"
                            :value="item.staff_no"
                            :disabled="item.status == 0"
                        >
                        </el-option>
                    </el-select>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="screen">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 列表配置 -->
        <el-drawer title="我是标题" :visible.sync="drawers" :direction="direction" :with-header="false">
            <div class="filterKey_box">
                <div class="box_header">
                    <span>列配置</span>
                    <i class="el-icon-close icon" @click="drawers = false"></i>
                </div>
                <div class="box_content">
                    <div class="small_box">
                        <div class="text">
                            <span class="big">已显示字段</span>
                            <span class="small">拖动可调整字段顺序</span>
                        </div>
                        <ul class="ul">
                            <draggable
                                :list="keyList"
                                class="list-group"
                                ghost-class="ghost"
                                :move="checkMove"
                                animation="1000"
                                force-fallback="true"
                                chosen-class="chosen"
                            >
                                <li
                                    class="li"
                                    v-for="(item, index) in keyList"
                                    :key="index"
                                    v-show="item.column_status == 1"
                                    @mouseover="showIndex = index"
                                    @mouseleave="showIndex = null"
                                >
                                    <i class="el-icon-s-grid icon"></i>
                                    {{ item.column_name }}
                                    <i class="el-icon-error delIcon" v-show="showIndex == index" @click="liClick('del', item, index)"></i>
                                </li>
                            </draggable>
                        </ul>
                    </div>
                    <div class="small_box">
                        <div class="text">
                            <span class="big">可选字段</span>
                            <span class="small"></span>
                        </div>
                        <ul class="ul">
                            <draggable :list="keyList" :disabled="true" class="list-group" ghost-class="ghost" :move="checkMove">
                                <transition-group>
                                    <li
                                        class="li hover"
                                        v-for="(item, index) in keyList"
                                        :key="index"
                                        v-show="item.column_status == 0 && item.field_status == 1"
                                        @mouseover="optionalIndex = index"
                                        @mouseleave="optionalIndex = null"
                                        @click="liClick('add', item, index)"
                                    >
                                        <i class="el-icon-circle-plus-outline icon2" v-show="optionalIndex == index"></i>
                                        {{ item.column_name }}
                                    </li>
                                </transition-group>
                            </draggable>
                        </ul>
                    </div>
                    <div class="box_btn">
                        <!-- <el-button class="float_l" @click="reset" style="font-size: 14px">恢复默认</el-button> -->
                        <el-button @click="keycancel" style="font-size: 14px">{{ $t('common.cancel') }}</el-button>
                        <el-button @click="keyConfirm" type="primary" style="font-size: 14px">{{ $t('common.confirm') }}</el-button>
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import {
    banktransferIndex,
    apiAllSelectBank,
    apiaddBank,
    apiDelBank,
    apicheckBank,
    apiModifyBank,
    banktransferImportr,
    apiBankAllCheck,
    apiGetinfo,
    apiGetListCorrespondingData,
    apiUpdateListCorrespondingData
} from '@/request/api';
import { translateColumns } from '@/utils/columnI18n';
export default {
    data() {
        return {
            query: {
                page: 1,
                page_size: 10,
                seek: '',
                type: '1',
                start_date: '',
                end_date: '',
                check: '0'
            },
            pageTotal: 0,
            command: 0,
            backData: [],
            drawer: false,
            form: { banktransfer_date: '' },
            pullData: {},
            rules: {
                banktransfer_date: [{ required: true, message: '请选择日期', trigger: 'blur' }],
                billtype_no: [{ required: true, message: '请选择单据类型', trigger: 'blur' }],
                outbank_no: [{ required: true, message: '请选择转出银行', trigger: 'blur' }],
                intbank_no: [{ required: true, message: '请选择转入银行', trigger: 'blur' }],
                currency_no: [{ required: true, message: '请选择币别', trigger: 'blur' }],
                amt: [{ required: true, message: '请选择金额', trigger: 'blur' }]
            },
            isAdd: true,
            dialogVisible: false,
            value2: '',
            systemSet: '',

            rkKeyList: [],
            originalRkKeyList: [], // 保存原始的列配置（包含所有语言）
            keyList: [],
            drawers: false,
            direction: 'rtl',
            showIndex: null,
            optionalIndex: null,
            refushTable: true,
            perData: ''
        };
    },
    mounted() {
        this.systemSet = JSON.parse(localStorage.getItem('systemSet'));

        // 处理传入的 bill_no 参数
        if (this.$route.query.bill_no) {
            this.query.seek = this.$route.query.bill_no;
        }

        this.getData();
        this.getPull();
        this.getTable();

        // 监听语言变化
        this.$watch(
            () => this.$i18n ? this.$i18n.locale : localStorage.getItem('language'),
            (newLang) => {
                // 语言变化时，重新转换列名
                if (this.originalRkKeyList && this.originalRkKeyList.length > 0) {
                    this.rkKeyList = translateColumns(this.originalRkKeyList, newLang || 'zh-CN');
                }
            }
        );
    },
    methods: {
        getData() {
            banktransferIndex({ ...this.query }).then((res) => {
                this.backData = res.data.data;
                this.pageTotal = res.data.count;
            });
        },
        getPull() {
            apiAllSelectBank().then((res) => {
                this.pullData = res.data;
            });
        },
        changeDate(value) {
            if (value) {
                this.query.type = '';
                this.query.start_date = value[0];
                this.query.end_date = value[1];
            } else {
                this.query.type = '1';
                this.query.start_date = '';
                this.query.end_date = '';
            }
        },

        // //跳转
        handleDetails(row) {
            this.$router.push({
                path: '/' + this.$route.query.page,
                query: {
                    bill_no: row.banktransfer_no
                }
            });
        },
        //列配置相关接口
        getTable() {
            apiGetListCorrespondingData({
                id: '36'
            }).then((res) => {
                // this.rkKeyList = res.data;
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言）
                    this.originalRkKeyList = res.data;
                    // 根据当前语言转换列名
                    this.rkKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
        },
        changeTable() {
            this.drawers = true;
            this.keyList = this.rkKeyList.map((item) => item);
        },
        liClick(type, item, index) {
            if (type === 'del') {
                this.$set(this.keyList[index], 'column_status', '0');
            } else if (type === 'add') {
                this.$set(this.keyList[index], 'column_status', '1');
            }
        },
        checkMove(item) {},
        keycancel() {
            this.drawers = false;
            this.getTable();
        },
        keyConfirm() {
            let keyList = JSON.stringify(this.keyList);
            apiUpdateListCorrespondingData({
                column: keyList,
                id: '36'
            }).then((res) => {
                this.drawers = false;
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.refushTable = !this.refushTable;
                } else if (res.code == 4000) {
                    this.$message.warning(res.data.info);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 筛选
        screen() {
            this.dialogVisible = false;
            this.getData();
        },
        // 切换日期搜素
        handleClick(tab, event) {
            this.getData();
        },
        // 搜索
        searchIt() {
            this.getData();
        },
        // 批量操作
        handleCommand(command) {
            if (command == 4) {
                this.outExcel();
            } else if (command == 1 || command == 2) {
                this.check(command);
            } else if (command == 5) {
                document.querySelector('.biaoge input').click();
            } else if (command == 3) {
                this.deleteIts();
            } else if (command == 6) {
                this.outExcel(1);
            }
        },
        deleteIts() {
            let data = this.$refs.table.getCheckboxRecords();
            if (data.length == 0) {
                this.$message.warning('请选择需要操作的数据');
                return;
            }
            let idArr = [];
            data.forEach((item) => {
                idArr.push(item.banktransfer_no);
            });
            let ids = idArr.join(',');
            this.$confirm('确定要删除该账户过账单吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    apiDelBank({
                        banktransfer_no: ids
                    }).then((res) => {
                        if (res.code == 2000) {
                            this.$message({ message: '删除成功', type: 'success' });
                            this.getData();
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {});
        },
        // 导出
        outExcel(type) {
            var username;
            apiGetinfo({}).then((res) => {
                if (res.code == 2000) {
                    username = res.data.login_staff;
                    this.$axios
                        .get(this.$baseURL + 'banktransfer_export', {
                            params: {
                                token: sessionStorage.getItem('userToken'),
                                login_staff: username,
                                type: type
                            },
                            responseType: 'arraybuffer'
                        })
                        .then((response) => {
                            //创建一个blob对象,file的一种
                            let blob = new Blob([response.data], { type: 'application/x-xls' });
                            let link = document.createElement('a');
                            link.href = window.URL.createObjectURL(blob);
                            if (type == 1) {
                                link.download = '模板.xlsx';
                            } else {
                                link.download = '账户过账.xlsx';
                            }

                            link.click();
                        });
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 导入
        inExcel(file) {
            let data = new FormData(); //创建form对象
            data.append('file', file.raw);
            banktransferImportr(data).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.getData();
                } else {
                    let str = [];
                    var s = '';
                    str = res.data.info;
                    for (let i = 0; i < str.length; i++) {
                        s += str[i].error + '<br/><br/>';
                    }
                    this.$message({
                        type: 'error',
                        showClose: true,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: s
                    });
                }
            });
        },
        // 审核
        check(command) {
            let check;
            if (command == 1) {
                check = 1;
            } else if (command == 2) {
                check = 0;
            }
            let data = this.$refs.table.getCheckboxRecords();
            if (data.length == 0) {
                this.$message.warning('请选择需要操作的数据');
                return;
            }

            let idArr = [];
            data.forEach((item) => {
                idArr.push(item.banktransfer_no);
            });
            let ids = idArr.join(',');
            apiBankAllCheck({
                check: check,
                banktransfer_no: ids
            }).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.getData();
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 新建
        add() {
            this.form = {};
            this.isAdd = true;
            this.drawer = true;
            this.$set(this.form, 'banktransfer_date', this.$getTime());
            const keys = Object.keys(this.pullData);
            const formKeys = keys.map((key) => `${key}_no`);
            keys.forEach((key, index) => {
                if (Array.isArray(this.pullData[key])) {
                    // 确保 this.pullData[key] 是一个数组，而不是 undefined 或 null
                    const defaultItem = this.pullData[key].find((item) => item.isdefault == 1);
                    if (defaultItem) {
                        // 确保 defaultItem 和属性 formKeys[index] 存在
                        if (defaultItem.hasOwnProperty(formKeys[index])) {
                            this.form[formKeys[index]] = defaultItem[formKeys[index]];
                        } else {
                            console.warn(`Property ${formKeys[index]} does not exist on defaultItem`);
                            this.form[formKeys[index]] = ''; // 如果属性不存在，给它赋个默认值
                        }
                    } else {
                        // 如果没有找到 defaultItem，可能需要给 this.form[formKeys[index]] 设置一个默认值
                        console.warn(`No defaultItem found for key ${key}`);
                        this.form[formKeys[index]] = '';
                    }
                } else {
                    // 如果 this.pullData[key] 不是一个数组，输出警告
                    console.warn(`Expected an array for key ${key}, but found ${typeof this.pullData[key]}`);
                }
            });
        },
        addIt() {
            this.$refs.from.validate((valid) => {
                if (valid) {
                    if (this.isAdd) {
                        this.$load.show();
                        apiaddBank({ ...this.form }).then((res) => {
                            if (res.code == 2000) {
                                this.$message.success(res.msg);
                                this.drawer = false;
                                this.getData();
                                this.$load.close();
                            } else {
                                this.$load.close();
                                this.$message.error(res.data.info);
                            }
                        });
                    } else {
                        this.$load.show();
                        apiModifyBank({ ...this.form }).then((res) => {
                            if (res.code == 2000) {
                                this.$message.success(res.msg);
                                this.drawer = false;
                                this.getData();
                                this.$load.close();
                            } else {
                                this.$load.close();
                                this.$message.error(res.data.info);
                            }
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        Edit(row) {
            this.form = row;
            this.isAdd = false;
            this.drawer = true;
        },
        deleteIt(row) {
            this.$confirm('确定要删除该账户过账单吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    apiDelBank({
                        banktransfer_no: row.banktransfer_no
                    }).then((res) => {
                        if (res.code == 2000) {
                            this.$message({ message: '删除成功', type: 'success' });
                            this.getData();
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {});
        },
        Check(row) {
            let check;
            if (row.check == 0) {
                check = 1;
            } else {
                check = 0;
            }
            apicheckBank({
                banktransfer_no: row.banktransfer_no,
                check: check
            }).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.getData();
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        refush() {
            (this.query = {
                page: 1,
                page_size: 10,
                seek: '',
                type: '1',
                start_date: '',
                end_date: '',
                check: '0'
            }),
                this.getData();
        },
        // 表尾合计-----------------------------------------------
        footerMethod({ columns, data }) {
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 1) {
                        return '合计';
                    } else if (column.property == 'amt') {
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.amt)}`;
                    } else {
                        return '-';
                    }
                })
            ];
        },
        //分页导航----------------------------------------------------------------------------------------------------
        handlePageChange(val) {
            this.query.page = val;
            this.getData();
        },
        pageSizeChange(val) {
            this.query.page_size = val;
            this.getData();
        }
    }
};
</script>

<style scoped lang="scss">
/deep/.el-tabs__nav-wrap::after {
    background-color: #fff;
}
/deep/.el-tabs__item {
    width: 88px;
    text-align: center;
    padding: 0;
    font-size: 14px;
}
/deep/.el-tabs__active-bar {
    width: 88px !important;
}
/deep/.el-drawer__header {
    border-bottom: 1px solid #e7e7e7;
    color: #000;
    font-size: 16px;
    margin: 0;
    padding: 15px 20px;
}
.header_warpper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
        display: flex;
        align-items: center;
    }
}
.drawer {
    width: 100%;
    height: 100%;
    position: relative;
}
.dialog-footer {
    width: 100%;
    position: absolute;
    right: 0px;
    bottom: 0px;
    border-top: 1px solid #e7e7e7;
    text-align: right;
    height: 56px;
    line-height: 56px;
    padding: 0 20px;
    box-sizing: border-box;
}
.dialog {
    .block {
        display: flex;
        margin-bottom: 24px;
        p {
            display: inline-block;
            width: 88px;
        }
    }
}
</style>
